import i18next from 'i18next';
import {lazy} from 'react';
import {getExactHiddenRoute, getExactRoute} from 'util/react';

import EN from './i18n/en.json';
import LT from './i18n/lt.json';

i18next.addResourceBundle('en', 'company', EN);
i18next.addResourceBundle('lt', 'company', LT);

export const CompanyNewRoute = getExactHiddenRoute('company', 'menu.edit', '/company/new', lazy(() => import('./layout/CompanyEditLayout')), null, ['admin']);
export const CompanyEditRoute = getExactHiddenRoute('company', 'menu.edit', '/company/:id', lazy(() => import('./layout/CompanyEditLayout')), null, ['admin']);
export const CompanyListRoute = getExactRoute('company', 'menu.list', '/company', lazy(() => import('./layout/CompanyListLayout')), null, ['admin']);


const CompanyRoute = (
  <>
    {CompanyListRoute}
    {CompanyEditRoute}
    {CompanyNewRoute}
  </>
);

export default CompanyRoute;
